import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import Collect from '@fiverr-private/collect';
import GigWrapper from '../Components/GigWrapper/GigWrapper';
import SlideImage from '../Components/Media/SlideImage';
import Title from '../Components/Title';
import Price from '../Components/Price';
import Rating from '../Components/Rating';
import ContextualLink from '../Components/ContextualLink';
import withTransformProps from '../hoc/withTransformProps';
import { listviewCardTransformer } from '../utils/transformers/listview';
import { createClickedElement, trackGigForClickType, enrichGigTracker } from '../utils';
import LoadingGigCard from '../loading/LoadingGigCard';
import { SmallListViewCardType } from '../types';
import { ELEMENTS_NAME, ELEMENTS_TYPE, URL_TARGET } from '../Components/constants';
import './index.scss';
import { LIST_VIEW_CARD_SMALL } from '../../GigCardListings/utils/constants';

class ListViewCardSml extends Component {
    getChildContext() {
        const { tracker } = this.props;

        return { ...enrichGigTracker(tracker, this.props) };
    }

    render() {
        const {
            uId,
            id,
            url,
            title,
            localizedTitle,
            translatedTitle,
            showTranslatedUGC,
            price,
            priceLabelType,
            isPro,
            seller,
            ratings,
            asset,
            isLoading,
            lazyLoad,
            urlTarget = URL_TARGET.self,
            collectProps,
            ExternalWrapper,
            isPromotedGig = false,
            hidePrefix = true,
            priceDisplayStatus,
        } = this.props;

        const { trackEvent } = this.getChildContext();

        const sellerPrefix = isPromotedGig
            ? 'gig_cards.badges.promoted_gigs.seller_name_prefix.ad_by'
            : 'gig_listings.gig_cards.by';
        const sellerName = seller.displayName || seller.name;

        return (
            <GigWrapper
                type={LIST_VIEW_CARD_SMALL}
                uId={uId}
                isPro={isPro}
                isLoading={isLoading}
                classes={['small-list-view-card']}
                LoadingComponent={LoadingGigCard}
                ExternalWrapper={ExternalWrapper}
                gig={this.props}
            >
                <div className="small-list-view-card">
                    <header>
                        <div className="side-image">
                            <ContextualLink
                                href={url}
                                target={urlTarget}
                                onMouseDown={(e) => trackGigForClickType(e.button, trackEvent, clickedElement)}
                            >
                                <SlideImage asset={asset} lazy={lazyLoad} />
                            </ContextualLink>
                            <div className="collect-container">
                                <Collect
                                    {...collectProps}
                                    resource={{ id: id.toString(), type: Collect.RESOURCE_TYPES.GIG }}
                                    showMenu={false}
                                    className="card-collect"
                                />
                            </div>
                        </div>
                        <aside className="header-right">
                            <div className="title-fav-container">
                                <Title
                                    hidePrefix={hidePrefix}
                                    title={title}
                                    showTranslatedUGC={showTranslatedUGC}
                                    localizedTitle={localizedTitle}
                                    translatedTitle={translatedTitle}
                                    url={url}
                                    isPro={isPro}
                                    urlTarget={urlTarget}
                                />
                            </div>
                            <ContextualLink title={seller.name} href={seller.url} className="seller-name">
                                <I18n k={sellerPrefix} />
                                &nbsp;{sellerName}
                            </ContextualLink>
                        </aside>
                    </header>
                    <footer>
                        <div className="rating-badge-container">
                            <Rating {...ratings} />
                        </div>
                        <Price
                            priceDisplayStatus={priceDisplayStatus}
                            url={url}
                            price={price}
                            priceLabelType={priceLabelType}
                            showFrom
                        />
                    </footer>
                </div>
            </GigWrapper>
        );
    }
}

ListViewCardSml.propTypes = SmallListViewCardType;

ListViewCardSml.childContextTypes = {
    trackEvent: PropTypes.func,
    trackImpression: PropTypes.func,
};

ListViewCardSml.defaultProps = {
    showTranslatedUGC: false,
};

export const clickedElement = createClickedElement(ELEMENTS_NAME.GIG_IMAGE, ELEMENTS_TYPE.LINK);

export default withTransformProps(listviewCardTransformer)(ListViewCardSml);
